import React from 'react';

const LinkedinIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
        <path fill="#0E76A8" fillRule="evenodd" d="M0 12C0 5.374 5.374 0 12 0s12 5.374 12 12-5.374 12-12 12S0 18.626 0 12zm5.59 6.14h2.923V9.349H5.59v8.793zm1.462-9.993h-.02c-.98 0-1.614-.675-1.614-1.518 0-.863.653-1.52 1.653-1.52s1.615.657 1.634 1.52c0 .843-.634 1.518-1.653 1.518zm9.077 9.994h2.922v-5.042c0-2.7-1.442-3.957-3.364-3.957-1.551 0-2.246.852-2.634 1.451V9.348H10.13c.039.825 0 8.793 0 8.793h2.923v-4.91c0-.263.018-.526.096-.714.211-.525.692-1.069 1.5-1.069 1.057 0 1.48.807 1.48 1.989v4.704z" clipRule="evenodd"/>
    </svg>
)

export default LinkedinIcon;
